// extracted by mini-css-extract-plugin
module.exports = {"container":"i_CM","icon":"i_CN","simple":"i_CO","label":"i_CP","embedded":"i_CQ"};